import {mixins} from "../app/mixin";
import useVuelidate from '@vuelidate/core'
import {required, email} from "@vuelidate/validators";

mixins.push({
    el: '.webinars',
    delimiters: ['${', '}'],
    data: () => ({
        v: useVuelidate(),
        wpAPI: window.wpAPI,
        webinars: window.webinars,
        currentYear: new Date().getFullYear(),
        selectedYear: '',
        selectedMonth: 0,
        webinarDetails: null,
        email: '',
        status: ''
    }), validations: {
        email: {required, email}
    }, computed: {
        typeList() {
            const typeList = []
            const currentYearWebinars = this.webinars[this.currentYear]
            for (const month in currentYearWebinars) {
                if (currentYearWebinars[month].length > 0) {
                    currentYearWebinars[month].forEach((webinar) => typeList.push(webinar.type))
                }
            }
            return [...new Set(typeList)]
        }, yearList() {
            return Object.keys(this.webinars)
        }, isEventCompleted() {
            if (new Date(this.webinarDetails.date.split('T')[0] + 'T' + this.webinarDetails.startTime) < Date.now()) {
                return true;
            }

            return false;
        }
    }, beforeMount() {
        this.selectedYear = this.currentYear
    }, methods: {
        toggleMonth(monthIndex) {
            this.selectedMonth = monthIndex;
        }, setWebinarDetails(year, month, index) {
            this.webinarDetails = this.webinars[year][month][index];
        }, formatDate(date) {
            var parts = date.split('T')[0].split('-');

            return parts[2] + '.' + parts[1] + '.' + parts[0];
        }, goToWebinarUrl(url) {
            window.open(url, '_blank')
        }, closeDialog() {
            this.webinarDetails = null;
        }, async subscribeNewsletter() {
            // this.v.$touch() TODO
            if (!this.v.email.$anyError) {
                const response = await fetch(`${this.wpAPI}/wp-json/newsletter/v2/subscribers?client_key=52972eb0cdc9dd241d1905a5fa99ba93c7dea8d0&client_secret=6db399b9a184394d45355c0c0c8b9e294f4e982e`, {
                    method: "POST",
                    headers: {'Content-Type': 'application/json'},
                    body: JSON.stringify({
                        email: this.email
                    })
                }).then(r => {
                    this.status = 'SUCCESS';
                }).catch(() => {
                    this.status = 'ERROR';
                }).finally(() => {
                    this.closeDialog();
                    this.email = '';

                    setTimeout(() => {
                        this.status = '';
                    }, 15000);
                });
            }
        },
    },
});